<template>
    <loIndex>
        <loSection>
            <loArticle>
                <mdHtmlSlider
                    ref="mdHtmlSlider"
                    :data="sliderData"
            
                    @sendEvent="receiveEvent"
                ></mdHtmlSlider>
                <mdProductClass
                    ref="mdProductClass"
                    :data="productClassList"
            
                    @sendEvent="receiveEvent"
                ></mdProductClass>
            </loArticle>
        </loSection>
    </loIndex>
</template>

<script>
    import loIndex from '@/components/loIndex'
    import loSection from '@/components/loSection'
    import loArticle from '@/components/loArticle'
    import mdHtmlSlider from '@/components/mdHtmlSlider'
    import mdProductClass from '@/components/mdProductClass'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            loIndex,
            loSection,
            loArticle,
            mdHtmlSlider,
            mdProductClass,
        },
        data: function(){

            return {
                id: 'index',
                sliderData: [],
                productClassList: [],
                positionData: [], //大類卡片定位
                scrollPos: 0, //卷軸高度 + 視窗一半的高度
            }
        },
        watch: {
            productClass: {
                handler: function(){
                    this.initProductClassList();
                }
            },
        },
        computed: {
            ...mapState([
                'productClass',
            ]),
        },
        methods: {
            ...mapMutations([
                'catchError',
                'globalResizeFuncQueuePush',
                'globalResizeFuncQueueClear',
                'globalScrollFuncQueuePush',
                'globalScrollFuncQueueClear',
            ]),
            setHeaderBar: function(num){

                if( num < 5 ) {
                    this.$emit('sendEvent', 'setHeaderTransparent', true);
                }else {
                    this.$emit('sendEvent', 'setHeaderTransparent', false);
                }
            },
            UpdateSet: function() {
                let $ref = this.$refs.mdProductClass;
        
                $ref.UpdateSet();
            },
            UpdatePos: function(pos){
                let $productClassList = this.productClassList,
                    _every = $productClassList.every(item => item.active);

                let _scrollTop = window.pageYOffset,
                    _windowHeight = window.innerHeight,
                    _top = _scrollTop + _windowHeight * 1;

                this.setHeaderBar(_scrollTop);

                if( !_every ) {
                        
                    pos.forEach((item, index) => {

                        if( _top > item ) {
                            $productClassList[index].active = true;
                        }
                    });
                }
            },
            initProductClassList: function(){
                let $data = this.productClass,
                    $result = []

                $data.forEach((item, index) => {
                    
                    $result.push({
                        sn: item.class,
                        caption: item.title,
                        content: item.subtitle,
                        active: false,
                        image: item.imageurl,
                    });
                });
                
                this.$set(this, 'productClassList', $result);
            },
            getSliderData: function(){

                let _url = this.$siteTool.apiUrl({
                        class: 'MainPage',
                        func: 'Adverts',
                    }),
                    $condition = []

                return this.$http.post(_url, $condition);
            },
            initSliderData: function(res){
                let $data = [],
                    $result = []

                if(res){ //篩出有在使用的項次
                    $data = res.filter( item =>{
                        return item.isvalid !== 'False'
                    })
                    $data = $data.sort(function (a, b) { //排序
                        return parseFloat(a.sort) > parseFloat(b.sort) ? 1 : -1;
                    });
                }

                $data.forEach((item, index) => {

                    $result.push({
                        sn: index,
                        type: 'image',
                        href: item.link,
                        image: item.imageurl,
                    });
                });

                this.$set(this, 'sliderData', $result);
            },
            init: async function(){

                try {
                    let $response = await this.getSliderData();
                    
                    this.initSliderData($response);
                    this.initProductClassList();
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.init,
                    });
                }
            }
        },
        beforeCreate: function(){
            this.$emit('sendEvent', 'setHeaderTransparent', true);
        },
        created: function(){
            this.init();

            this.globalResizeFuncQueuePush({
                id: this.id,
                func: this.UpdateSet
            });

            this.globalScrollFuncQueuePush({
                id: this.id,
                func: this.UpdateSet
            });
        },
        destroyed: function(){
            this.$emit('sendEvent', 'setHeaderTransparent', false);

            this.globalResizeFuncQueueClear(this.id);
            this.globalScrollFuncQueueClear(this.id);
        },
    }
</script>

<style scoped lang="scss">

</style>
